export default __webpack_public_path__ + "static/poster-3-0597eeb0f6645bb86b245565969a2b42.webm";